import React from "react";
import "./TableToolbar.css";

const TableToolbar = ({ className = "", children }) => {
  const mergedClassName = ["table-toolbar", className].filter(Boolean).join(" ");
  return <div className={mergedClassName}>{children}</div>;
};

export default TableToolbar;
